<template>
  <button
    class="btn components-notifications-item flex-fill mb-3"
    :class="{
      'not-readed-bg': !item.visualized
    }"
    @click="action"
    :disabled="disable"
  >
    <div class="d-flex align-items-center flex-fill">
      <div>
        <img
          v-if="isCommentType && item.image_profile"
          :src="item.image_profile"
          :alt="item.name_reported"
          class="comment-user-img mr-3"
        />
        <div
          v-if="isCommentType && !item.image_profile"
          class="comment-user-img mr-3"
        >
          {{ item.name_reported[0] }}
        </div>
        <div
          v-if="item.notification_type == 'new_class_notice'"
          class="lesson-preview-img mr-3"
        >
          <div class="play-circle">
            <i class="icon-controller-play"></i>
          </div>
        </div>
        <div v-if="isAlert">
          <i class="icon-alert mr-3"></i>
        </div>
      </div>
      <div class="flex-fill">
        <div v-html="item.message" class="message-text mb-2"></div>
        <small class="text-capitalize">{{ date_info(item.updated_at) }}</small>
      </div>
      <div>
        <button @click.stop="showAction = !showAction" class="btn">
          <h2 class="text-secondary">...</h2>
        </button>
        <div v-if="showAction" class="action-wrapper">
          <button v-if="!item.to_read" class="btn" @click.stop="markAsRead">
            <i class="icon-check-circle mr-2"></i> Marcar como visualizada
          </button>
          <button class="btn" @click.stop="deleteNotification">
            <i class="icon-x mr-2"></i> Remover notificação
          </button>
        </div>
        <!-- <b-dropdown
          variant="link"
          class="mt-n2"
          toggle-class="text-decoration-none"
          right
          id="subdropdown"
        >
          <template #button-content>
            <loading :show="loadingAction">
              <h2 class="text-secondary">...</h2>
            </loading>
          </template>
          <b-dropdown-item v-if="!item.to_read" @click="markAsRead">
            <i class="icon-check-circle mr-2"></i> Marcar como visualizada
          </b-dropdown-item>
          <b-dropdown-item @click="deleteNotification">
            <i class="icon-x mr-2"></i> Remover notificação
          </b-dropdown-item>
        </b-dropdown> -->
      </div>
    </div>
  </button>
</template>
<script>
const TYPE_NOTIFICATION = {
  commented: "Comentou",
  liked: "Reagiu ao seu comentário",
  denounced: "Denunciou seu comentário",
  general_notices: "Avisos Geral",
  individual_notices: "Aviso Individual",
  received_report_comment: "Recebido Denuncia Comentário",
  new_class_notice: "Nova Aula Públicada"
};

import moment from "moment";
import "moment/locale/pt-br";

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showAction: false,
      isDropdown2Visible: false,
      loadingAction: false
    };
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", bvEvent => {
      if (bvEvent.componentId == "subdropdown") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", bvEvent => {
      if (bvEvent.componentId == "subdropdown") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
  },
  methods: {
    action() {
      if (this.isDropdown2Visible) return;

      this.markAsRead();

      if (this.item.link) {
        window.location.href = this.item.link;
      }
    },
    deleteNotification() {
      this.loadingAction = true;
      this.$store
        .dispatch("user/delete_notification", this.item.id)
        .then(() => {
          this.$message.success("A notificação foi apagada!");
          this.$emit("update");
        })
        .finally(() => {
          this.loadingAction = false;
          this.showAction = false;
        });
    },
    markAsRead() {
      this.loadingAction = true;
      this.$store
        .dispatch("user/read_notification", this.item.id)
        .then(() => {
          this.$message.success("A notificação foi marcada como visualizada!");
          this.$emit("update");
        })
        .finally(() => {
          this.showAction = false;
          this.loadingAction = false;
        });
    },
    date_info(dateString) {
      moment.locale("pb-br");
      return moment(dateString, "YYYY MM DD hh:mm:ss").fromNow();
    }
  },
  computed: {
    isAlert() {
      return (
        [
          "denounced",
          "received_report_comment",
          "general_notices",
          "individual_notices"
        ].indexOf(this.item.notification_type) != -1
      );
    },
    isCommentType() {
      return ["commented", "liked"].indexOf(this.item.notification_type) != -1;
    },
    disable() {
      return this.isAlert;
    }
  }
};
</script>
<style lang="scss" scoped>
.components-notifications-item {
  padding: 10px 14px 10px 10px;
  border-radius: 8px;
  min-height: 90px;
  z-index: 0;
  &:hover {
    filter: brightness(1.3);
  }
  &.not-readed-bg {
    background: #13251e;
  }

  display: flex;
  justify-content: flex-start;
  text-align: left;

  width: 100%;

  ::v-deep #subdropdown > .dropdown-menu {
    width: 200px !important;
    z-index: 2;

    .dropdown-item {
      border-radius: 8px;
      white-space: break-spaces;
      z-index: 9999;
      &:hover {
        border-radius: 8px;
      }
    }
  }

  &:disabled {
    opacity: 1 !important;
  }

  .comment-user-img {
    border-radius: 50%;
    height: 35px;
    width: 35px;

    font-size: 14px;
    color: #fff;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lesson-preview-img {
    border-radius: 8px;
    height: 75px;
    width: 75px;
    display: flex;
    align-items: center;
    justify-content: center;

    .play-circle {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      border: 3.01869px solid #fdfdfd;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        color: #fdfdfd;
        font-size: 18px;
        margin-left: 3px;
      }
    }
  }

  .icon-alert {
    font-size: 36px;
    color: #fff;
  }

  ::v-deep .message-text {
    word-break: break-word;
    text-overflow: ellipsis;
    & > * {
      font-size: 14px;
    }
    & > p {
      color: #fff;
      font-weight: normal;
    }
    b {
      color: #6b9b7e !important;
    }
  }

  small {
    color: #6b9b7e;
  }

  .action-wrapper {
    background: #131212;
    border-radius: 8px;
    position: absolute;
    right: 10px;
    bottom: 50px;
    z-index: 99999999;
    max-width: 220px;

    .btn {
      font-weight: normal;
      font-size: 14px;

      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
